module.exports = __webpack_public_path__ + "static/media/kwanuko_logo_horizontal.2a7c5568.png";